import {detailsPageDataHooks as DH} from '@wix/wix-events-data-hooks'
import React from 'react'
import {RsvpInfoButton} from '../rsvp-info-button'
import {TicketsUnavailableButtonProps} from './interfaces'

export const TicketsUnavailableButton: React.FC<TicketsUnavailableButtonProps> = ({
  ticketsUnavailableMessages,
  href,
}) => <RsvpInfoButton messages={ticketsUnavailableMessages} dataHook={DH.TICKETS_UNAVAILABLE} href={href} />
